import {
  AwsSimpleRecommendationsClient,
  AwsReservationSearchFilter,
  AwsReservationSearchRequest,
  AwsRightsizingSearchFilter,
  AwsRightsizingSearchRequest,
  ReservationPurchaseResult,
  RightSizingResult,
  SavingsPlansPurchaseResult,
  TrustedAdvisorResult,
} from "lib/ShiOneClient";
import type {
  AwsReservationsSearchRequest as AwsReservationsSearchRequestPayload,
  AwsRightsizingSearchRequest as AwsRightsizingSearchRequestPayload,
} from "../containers/Modules/Cloud/AWS/AwsSimpleRecommendations/helpers/AwsRecommendationHelpers";
import { ApiClientConfig } from "../auth/ApiClientConfig";
const api = new AwsSimpleRecommendationsClient(
  ApiClientConfig,
  import.meta.env.API_ENDPOINT
);

export function buildReservationSearchRequestModel(
  request: AwsReservationsSearchRequestPayload,
): AwsReservationSearchRequest {
  return new AwsReservationSearchRequest({
    searchFilterInclude: request.searchFilterInclude
      ? new AwsReservationSearchFilter(request.searchFilterInclude)
      : undefined,
    searchFilterExclude: request.searchFilterExclude
      ? new AwsReservationSearchFilter(request.searchFilterExclude)
      : undefined,
  });
}

export function buildRightsizingSearchRequestModel(
  request: AwsRightsizingSearchRequestPayload,
): AwsRightsizingSearchRequest {
  return new AwsRightsizingSearchRequest({
    searchFilterInclude: request.searchFilterInclude
      ? new AwsRightsizingSearchFilter(request.searchFilterInclude)
      : undefined,
    searchFilterExclude: request.searchFilterExclude
      ? new AwsRightsizingSearchFilter(request.searchFilterExclude)
      : undefined,
  });
}

export async function getRestTrustedAdvisor(): Promise<TrustedAdvisorResult[]> {
  return api.getTrustedAdvisor();
}

export async function loadInitialReservationPurchaseRecommendations(
): Promise<ReservationPurchaseResult[]> {
  return api.getReservationPurchaseRecommendations(
    new AwsReservationSearchRequest({}),
  );
}

export async function postRestReservationPurchaseRecommendations(
  request: AwsReservationsSearchRequestPayload,
): Promise<ReservationPurchaseResult[]> {
  return api.getReservationPurchaseRecommendations(
    buildReservationSearchRequestModel(request),
  );
}

export async function loadInitialRightsizingRecommendations(): Promise<
  RightSizingResult[]
> {
  return api.getRightsizingRecommendations(
    new AwsRightsizingSearchRequest({}),
  );
}

export async function postRestRightsizingRecommendations(
  request: AwsRightsizingSearchRequestPayload,
): Promise<RightSizingResult[]> {
  return api.getRightsizingRecommendations(
    buildRightsizingSearchRequestModel(request),
  );
}

export async function getRestSavingsPlanRecommendations(): Promise<
  SavingsPlansPurchaseResult[]
> {
  return api.getSavingsPlanRecommendations();
}
